import { render } from "./login.vue?vue&type=template&id=38bb32e3&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=38bb32e3&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bb32e3"]])

export default __exports__